/* global Swiper */

( function () {
	"use strict";

	/* ── Utility: convert any YouTube / Vimeo URL to an embed src ── */
	function getEmbedUrl( url ) {
		if ( ! url ) return null;

		// youtube.com/watch?v=ID  or  youtu.be/ID  or  youtube.com/shorts/ID
		var yt = url.match(
			/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
		);
		if ( yt ) {
			return "https://www.youtube.com/embed/" + yt[ 1 ] + "?autoplay=1&rel=0";
		}

		// vimeo.com/ID  or  vimeo.com/channels/.../ID
		var vm = url.match( /vimeo\.com\/(?:.*\/)?(\d+)/ );
		if ( vm ) {
			return "https://player.vimeo.com/video/" + vm[ 1 ] + "?autoplay=1";
		}

		// Already an embed URL — just append autoplay
		if ( url.indexOf( "embed" ) !== -1 ) {
			return url + ( url.indexOf( "?" ) !== -1 ? "&autoplay=1" : "?autoplay=1" );
		}

		return null; // unknown format → open in new tab
	}

	/* ── Play-button click handler ── */
	document.addEventListener( "click", function ( e ) {
		var btn = e.target.closest( ".stories-play-btn" );
		if ( ! btn ) return;

		var wrapper = btn.closest( ".stories-video-wrapper" );
		if ( ! wrapper ) return;

		var videoUrl  = wrapper.dataset.videoUrl;
		var embedSrc  = getEmbedUrl( videoUrl );

		if ( embedSrc ) {
			/* Replace the entire wrapper content with a responsive iframe */
			wrapper.innerHTML =
				'<iframe src="' + embedSrc + '" ' +
				'style="position:absolute;inset:0;width:100%;height:100%;border:0;" ' +
				'allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
			wrapper.style.position = "relative"; // ensure absolute child is anchored
		} else if ( videoUrl ) {
			window.open( videoUrl, "_blank", "noopener,noreferrer" );
		}
	} );

	/* ── Swiper init ── */
	function initStoriesSliders() {
		if ( typeof window.Swiper === "undefined" ) {
			return;
		}

		document.querySelectorAll( ".stories-swiper:not(.swiper-initialized)" ).forEach( function ( el ) {
			var section = el.closest( ".stories-slider-section" );
			var prevEl  = section ? section.querySelector( ".stories-prev" ) : null;
			var nextEl  = section ? section.querySelector( ".stories-next" ) : null;

			new window.Swiper( el, {
				loop:          true,
				slidesPerView: 1,
				speed:         500,
				navigation: {
					prevEl:        prevEl,
					nextEl:        nextEl,
					disabledClass: "stories-arrow-disabled",
				},
				a11y: {
					prevSlideMessage: "Previous story",
					nextSlideMessage: "Next story",
				},
			} );
		} );
	}

	/* Wait for both DOM + Swiper CDN */
	if ( document.readyState === "loading" ) {
		document.addEventListener( "DOMContentLoaded", initStoriesSliders );
	} else {
		initStoriesSliders();
	}
} )();
